module.exports = __webpack_public_path__ + "static/media/alan.24c2d4aa.png";